import { type CSSProperties } from 'react'

export interface AudioVisualizerProps {
  level: number // 0-1
  isActive: boolean
  barCount?: number
  className?: string
  style?: CSSProperties
}

/**
 * Headless audio visualizer — renders bars whose height reflects audio level.
 * Styling is left to the consumer via className/style.
 */
export function AudioVisualizer({
  level,
  isActive,
  barCount = 5,
  className,
  style,
}: AudioVisualizerProps) {
  const bars = Array.from({ length: barCount }, (_, i) => {
    const offset = Math.sin((i / barCount) * Math.PI)
    const height = isActive ? Math.max(0.1, level * offset) : 0.1
    return { index: i, height }
  })

  return (
    <div className={className} style={{ display: 'flex', alignItems: 'center', gap: 2, ...style }}>
      {bars.map((bar) => (
        <div
          key={bar.index}
          style={{
            width: 3,
            height: `${bar.height * 100}%`,
            minHeight: 2,
            borderRadius: 1,
            backgroundColor: 'currentColor',
            transition: 'height 0.1s ease',
          }}
        />
      ))}
    </div>
  )
}
